import { render, staticRenderFns } from "./ShareholdersModification.vue?vue&type=template&id=07664ff8"
import script from "./ShareholdersModification.vue?vue&type=script&lang=js"
export * from "./ShareholdersModification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports